//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapGetters } from 'vuex'
import { REQUEST_PRIORITIES } from './Request.js'
import ReportContentSection from '../Report/ReportContent/ReportContentSection.vue'

export default {
  components: {
    ReportContentSection
  },
  props: {
    request: {
      type: Object,
      default () {
        return {}
      }
    },
    requestRoles: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      requestPriorities: REQUEST_PRIORITIES,
      serviceObjectPriorities: [
        { name: 'Обычный объект обслуживания', value: 1 },
        { name: 'Приоритетный объект обслуживания', value: 2 },
        { name: 'Высокоприоритетный объект обслуживания', value: 3 }
      ]
    }
  },
  computed: {
    ...mapGetters({
      priorityConditions: 'getRequestPriorityConditions'
    }),
    requestPriorityReadonly: function () {
      return this.readonly || this.request._configuration.isFieldReadonly('requestPriority')
    },
    readonly: function () {
      return !this.requestRoles.hasEditAccess || this.requestRoles.roleExternalDispatcher
    }
  }
}

